<template lang="pug">

include ./forbidden

</template>

<script>

import Translatable from '@shared/mixins/translatable'

import List from './alphabet-list'

export default {
  extends: List,
  mixins: [Translatable],
}

</script>


// WEBPACK FOOTER //
// src/js/shared/components/alphabet/forbidden.vue